/*
 * @Author: your name
 * @Date: 2020-09-29 13:14:43
 * @LastEditTime: 2021-03-02 17:43:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \project\src\router\index.js
 */
import Vue from "vue";
import VueRouter from "vue-router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const router = new VueRouter({
  routes: [
    // {
    //   path: '/',
    //   name: 'indexNew',
    //   component: () => import( /* webpackChunkName:"login" */ '../views/indexNew.vue')
    // },
    {
      path: "/",
      redirect: "/login"
    },
    {
      path: "/login",
      name: "Login",
      component: () =>
        import(/* webpackChunkName:"login" */ "../views/Login.vue")
    },
    {
      path: "/ApplyMembership",
      name: "ApplyMembership",
      component: () =>
        import(
          /* webpackChunkName:"ApplyMembership" */ "../views/ApplyMembership.vue"
        )
    },
    {
      path: "/adminGraph",
      name: "exportAdminGraph",
      component: () =>
        import(
          /* webpackChunkName:"exportAdminGraph" */ "../views/Home/AdminMember/AdminGraph.vue"
        )
    },
    {
      path: "/home",
      name: "Home",
      redirect: to => {
        let roleType = window.sessionStorage.getItem("roleType");
        if (roleType == 1) {
          return "/home/admin";
        } else if (roleType == 2) {
          return "/home/adminManagement";
        } else if (roleType == 3) {
          return "/home/management";
        }
      },
      component: () =>
        import(/* webpackChunkName:"home" */ "../views/Home/Home.vue"),
      children: [
        {
          path: "/home/admin",
          name: "Admin",
          component: () =>
            import(
              /* webpackChunkName:"home_admin" */ "../views/Home/Admin/Admin.vue"
            )
        },
        {
          path: "/home/adminManagement",
          name: "AdminManagement",

          component: () =>
            import(
              /* webpackChunkName:"home_adminManagement" */ "../views/Home/AdminMember/AdminManagement.vue"
            )
        },
        {
          path: "/home/adminProduct",
          name: "AdminProduct",
          component: () =>
            import(
              /* webpackChunkName:"home_adminProduct" */ "../views/Home/AdminMember/AdminProduct.vue"
            )
        },
        {
          path: "/home/adminApplication",
          name: "AdminApplication",
          component: () =>
            import(
              /* webpackChunkName:"home_adminApplication" */ "../views/Home/AdminMember/AdminApplication.vue"
            )
        },
        {
          path: "/home/adminNote",
          name: "AdminNote",
          component: () =>
            import(
              /* webpackChunkName:"home_adminNote" */ "../views/Home/AdminMember/AdminNote.vue"
            )
        },
        {
          path: "/home/adminGraph",
          name: "AdminGraph",
          component: () =>
            import(
              /* webpackChunkName:"home_adminGraph" */ "../views/Home/AdminMember/AdminGraph.vue"
            )
        },
        {
          path: "/home/adminOperation",
          name: "AdminOperation",
          component: () =>
            import(
              /* webpackChunkName:"home_adminOperation" */ "../views/Home/AdminMember/AdminOperation.vue"
            )
        },
        {
          path: "/home/management",
          name: "Management",
          component: () =>
            import(
              /* webpackChunkName:"home_member" */ "../views/Home/Member/Management/Management.vue"
            )
        },
        {
          path: "/home/application",
          name: "Application",
          component: () =>
            import(
              /* webpackChunkName:"home_member" */ "../views/Home/Member/Application.vue"
            )
        },
        {
          path: "/home/product",
          name: "Product",
          component: () =>
            import(
              /* webpackChunkName:"home_member" */ "../views/Home/Member/Product.vue"
            )
        },
        {
          path: "/home/operation",
          name: "Operation",
          component: () =>
            import(
              /* webpackChunkName:"home_member" */ "../views/Home/Member/Operation.vue"
            )
        },
        {
          path: "/home/info",
          name: "Info",
          component: () =>
            import(/* webpackChunkName:"home_info" */ "../views/Home/Info.vue")
        },
        {
          path: "/home/remind",
          name: "Remind",
          component: () =>
            import(
              /* webpackChunkName:"home_remind" */ "../views/Home/Remind.vue"
            )
        },
        {
          path: "/home/todo",
          name: "Todo",
          component: () =>
            import(
              /* webpackChunkName:"home_member" */ "../views/Home/Todo.vue"
            )
        },
        {
          path: "/home/questionnaire",
          name: "Questionnaire",
          component: () =>
            import(
              /* webpackChunkName:"home_member" */ "../views/Home/common/Questionnaire.vue"
            )
        },
        {
          path: "/home/detail",
          name: "Detail",
          component: () =>
            import(
              /* webpackChunkName:"home_detail" */ "../views/Home/Detail.vue"
            )
        }
      ]
    }
  ]
});
router.beforeEach((to, from, next) => {
  if (to.name == "indexNew") {
    document.title = "";
    let link =
      document.querySelector("link[rel='icon']") ||
      document.createElement("link");
    link.href = null;
  } else {
    document.title = "上海信用服务行业综合智慧数据库管理平台";
    let link =
      document.querySelector("link[rel='icon']") ||
      document.createElement("link");
    link.href = require("@/assets/img/logo.png");
  };

  if (
    to.name == "Login" ||
    to.name == "indexNew" ||
    to.name == "ApplyMembership" ||
    to.name == "exportAdminGraph"
  )
    return next();

  const token = sessionStorage.getItem("token");
  if (!token) return next({ name: "Login" });
  // 每次切换页面时，调用进度条
  NProgress.start();
  next();
});
router.afterEach(() => {
  // 在即将进入新的页面组件前，关闭掉进度条
  NProgress.done();
});
export default router;
